(function () {
    'use strict';

    var controllerId = 'navMenuController';
    var module = angular.module('inoApp.directives.layout');

    module.directive('layoutNavMenu', [function () {
        var directive = {
            restrict: 'AE',
            replace: false,
            controller: controllerId,
            controllerAs: 'navMenuVm',
            templateUrl: 'templates/core/layout/navMenu.html'
        };

        return directive;
    }]);
    
    module.controller(controllerId, ['$filter', '$state', navMenuController]);

    function navMenuController($filter, $state) {
        var vm = this;

        //vm.isSelected = isSelected;
        vm.menuInfos = [];
        vm.currentState = currentState;

        activate();

        function activate() {
            getNavRoutes();
        }

        function getNavRoutes() {
            vm.menuInfos.length = 0;
            var menuInfos = [];
            var allStates = $state.get();
            allStates.forEach(function (state, index) {
                if (state.data && state.data.settings && !state.parent) {
                    var subMenuInfos = null;
                    if (state.abstract) {
                        // check for child states
                        var childrenStates = allStates.filter(function (s) {
                            return (s.parent === state.name);
                        });
                        childrenStates = $filter('orderBy')(childrenStates, 'data.settings.nav');

                        subMenuInfos = [];
                        for (var i = 0; i < childrenStates.length; i++) {
                            var childState = childrenStates[i];
                            if (childState.data && childState.data.settings && !childState.data.hide)
                                subMenuInfos.push({ stateName: childState.name, resourceKey: childState.data.settings.titleResourceKey, iconClass: childState.data.settings.iconClass, nav: state.data.settings.nav });
                        }
                    }

                    menuInfos.push({ stateName: state.name, data: state.data, resourceKey: state.data.settings.titleResourceKey, subMenuInfos: subMenuInfos, iconClass: state.data.settings.iconClass, nav: state.data.settings.nav });
                }
            });

            vm.menuInfos = $filter('orderBy')(menuInfos, 'nav');

        }

        function currentState() {
            if ($state.$current)
                return $state.$current.name;

            return '';
        }
    };
})();